// extracted by mini-css-extract-plugin
export var currencyInput = "_l5-1";
export var currencySymbol = "_l5-0";